function initDesktopNavigation() {
    var navigationTimeout;
    $('#mainNav > .level1 > li').hover(
        function() {
            clearTimeout(navigationTimeout);
            if ($('#mainNav > .level1 > li .navSubnavRow:visible').length > 0 && $(this).children('.navSubnavRow:visible').length == 0) {
                $('#mainNav > .level1 > li .navSubnavRow:visible').hide();
                $(this).find('.navSubnavRow').show();
            } else {
                $(this).find('.navSubnavRow').fadeIn(300);
            }
        }, function() {
            var hoverElement = this;
            navigationTimeout = setTimeout(function() {
                $(hoverElement).find('.navSubnavRow').fadeOut(300);
            }, 150);
        }
    );
    /*$('.languageSwitchSelected').click(function() {
        $(this).parent().find('ul').slideToggle('fast');
        $(this).toggleClass('toggled');
    });*/
}

function initMobileNavigation() {
    var toggleMainMenu = function() {
        var button = $('.headerResponsiveMenu button');
        var mainNav = $('#mainNav');

        mainNav.css('overflow', 'visible');
        mainNav.height($('body').height() - 62);


        if ($('body').css('overflow') != 'hidden') {
            $('body').css('overflow', 'hidden');
        } else {
            $('body').css('overflow', 'visible');
        }

        if ($('#metaTop:visible').length > 0) {
            $('.headerResponsiveOptions button.options').toggleClass('active');
            $('#metaTop').animate({width: 'toggle'}, 'fast');
        }

        button.toggleClass('active');
        $('#mainNav').animate({width: 'toggle'}, 'fast', null, function() {
            $('#mainNav .navSubnavRow').hide();
        });

        if (button.hasClass('active')) {
            $('#content-main').on('touchstart', toggleMainMenu);
        } else {
            $('#content-main').off('touchstart');
        }
    };
    $('.headerResponsiveMenu button').click(toggleMainMenu);

    $('#mainNav > .level1 > li.hasSub > a').click(function (event) {
        $('#mainNav').css('overflow', 'hidden');
        $(this).siblings('.navSubnavRow').animate({width: 'show'}, 'fast');
        event.preventDefault();
    });

    $('#mainNav .level2 > li.menu-back').click(function () {
        $('#mainNav').css('overflow', 'auto');
        $('#mainNav .navSubnavRow:visible').animate({width: 'hide'}, 'fast');
        return false;
    });

    $('.headerResponsiveOptions button.options').click(function () {
        if ($('#mainNav:visible').length > 0) {
            $('.headerResponsiveMenu button').toggleClass('active');
            $('#mainNav').animate({width: 'toggle'}, 'fast');
        }

        $(this).toggleClass('active');
        $('#metaTop').animate({width: 'toggle'}, 'fast');
    });
}

function resetNavigation() {
    $('#mainNav > .level1 > li').off();
    $('#mainNav > .level1 > li > a').off();
    $('.headerResponsiveMenu button').off();
    $('.headerResponsiveOptions button.options').off();
    /*$('.languageSwitchSelected').off();*/
    $('#mainNav').css('overflow', 'visible');

    if(window.innerWidth > ENV.displaySizes.desktop) {
        $('#mainNav').css('display', '');
        $('#metaTop').css('display', '');
        $('.headerResponsiveMenu button').removeClass('active');
        $('.headerResponsiveOptions button.options').removeClass('active');
        initDesktopNavigation();
    } else {
        initMobileNavigation();
    }
}

$(function() {
    // add parent link for submenu
    // TODO do this via TypoScript
    $('.menu-parent').each(function() {
        $(this).html($(this).parents('li').first().children('a').clone())
    })


    /*$('.languageSwitch').prepend('<div class="languageSwitchSelected" >'+$('.languageSwitch').find('.active').find('a').text()+'</div>');
    $('.languageSwitch ul li.active a').click(function() {
        return false;
    });*/

    resetNavigation();
    $(window).resize(function() {
        resetNavigation();
    })


    // Navigation Highlights
    $('#highlights *[data-highlight]').each(function () {
        $('#' + $(this).attr('data-highlight')).html($(this));
    });
});
